var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { GLASS_BREAKAGE_TRAD_KEYS } from '@declaration/constants/glassBreakageDamageConstants';
const claim = namespace('claim');
const qualification = namespace('qualification');
let GlassBreakagePersonalPropertiesBelongsToMeQuestion = class GlassBreakagePersonalPropertiesBelongsToMeQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.yesNoQuestionValuesAndTradKeys = YES_OR_NO_CHOICES;
    }
    get panelTitle() {
        return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['personal-properties-belonging-panel-title']);
    }
    get sidebarTitle() {
        const key = GLASS_BREAKAGE_TRAD_KEYS['personal-properties-belonging-sidebar_title'];
        return key && this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    updateClaim(personalPropertiesBelongsToMe) {
        this.updateAndSaveQualification({
            qualificationPayload: { personalPropertiesBelongsToMe },
            step: this.step,
        });
    }
    get answer() {
        if (this.qualification.personalPropertiesBelongsToMe === null)
            return null;
        return this.qualification.personalPropertiesBelongsToMe
            ? this.$tc('claim.damage.glass_breakage.personal_properties_belonging.yes')
            : this.$tc('claim.damage.glass_breakage.personal_properties_belonging.no');
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], GlassBreakagePersonalPropertiesBelongsToMeQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], GlassBreakagePersonalPropertiesBelongsToMeQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], GlassBreakagePersonalPropertiesBelongsToMeQuestion.prototype, "updateAndSaveQualification", void 0);
GlassBreakagePersonalPropertiesBelongsToMeQuestion = __decorate([
    Component({
        components: { QuestionPanel, RadioPrimaryButton },
        props: QuestionProps,
    })
], GlassBreakagePersonalPropertiesBelongsToMeQuestion);
export default GlassBreakagePersonalPropertiesBelongsToMeQuestion;
